
import TableList from "@components/templates/tablelist";
import { HttpDataConfigList, HttpDeleteDataConfigOne, HttpGetOurWarehouseList } from "@/service/bespeak";
import { mapState, mapGetters } from "vuex";
import compUpload from "@components/templates/selectupload";
import comIndex from './update'
import comBathUpdate from './bathUpdate'
export default {
    mixins: [TableList],
    components: {
        compUpload,
        comIndex,
        comBathUpdate
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            ourwarehouseList: [],
        };
    },
    created() {
        // 请求仓库
        HttpGetOurWarehouseList().then(res => {
            this.ourwarehouseList = res.data.map(item => {
                return {
                    value: item.id,
                    label: item.code + '(' + item.title + ')'
                }
            })
        })
    },
    methods: {
        ajaxRequest: HttpDataConfigList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'dataconfigUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'dataconfigUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { id: params },
                        title: "删除",
                        ajaxRequest: HttpDeleteDataConfigOne
                    }
                    break;
                case "importExcel":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        name: "multipartFile",
                        component: "compUpload",
                        actionurl: process.env.VUE_APP_APIURL_FBB + '/api/v2/ReserveWarehouseCfg/batchImport',
                        showdownload: 0,
                        downrul: process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveWarehouseCfg/importTemplate",
                        formdata: [
                            {
                                label: '是否包含节假日',
                                tag: 'vSelect',
                                key: 'isContainHolidayAndWeek',
                                options: [
                                    { label: "是", value: '1' },
                                    { label: "否", value: '0' },
                                ],
                                props: {
                                    clearable: true,
                                },
                                labelWidth: 120,
                                span: 24,
                            },
                        ]
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveWarehouseCfg/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    );
                    break;
                case "bathUpdate":
                    this.operate = {
                        title: '批量修改',
                        show: true,
                        width: 1200,
                        component: "comBathUpdate",
                        showFooter: false
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: '删除',
                show: true,
                params: id,
                operate: 'delete'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillTransferWarehouse']),
        ToolsData() {
            return [
                {
                    name: '新增',
                    operate: 'add',
                    theme: 'primary'
                },
                {
                    name: "导入",
                    operate: "importExcel",
                    theme: "info",
                },
                {
                    name: "导出",
                    operate: "export",
                    theme: "success",
                },
                {
                    name: "批量修改",
                    operate: "bathUpdate",
                    theme: "primary",
                },
            ]

        },
        SearchsData() {
            return [
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.ourwarehouseList,
                    props: {
                        filterable: true,
                    },
                    show: true,
                },

                {
                    label: '预约类型',
                    tag: 'vSelect',
                    key: 'EQ_bookingType',
                    options: [
                        { label: "加急", value: '0' },
                        { label: "普通", value: '1' },
                    ],
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: '单据类型',
                    tag: 'vSelect',
                    key: 'EQ_goodTypeCode',
                    options: [
                        { label: "FCL", value: 'FCL' },
                        { label: "LTL", value: 'LTL' },
                        { label: "Express", value: 'Express' },
                    ],
                    props: {
                        filterable: true,
                    },
                    show: true,
                },
                {
                    label: '可约日期',
                    tag: 'vDatepicker',
                    key: 'BT_reserveDate',
                    style: "width:180px",
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    width: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: '仓库',
                    render: (h, { row }) => this.findRenderLabel(this.getBillTransferWarehouse, row.warehouseId),
                },
                {
                    title: '预约类型',

                    render: (h, { row }) => {
                        return <div>{row.bookingType == 0 ? '加急' : '普通' || '--'}</div>
                    }
                },
                {
                    title: '可约日期',
                    render: (h, { row }) => {
                        return <div>{row.reserveDate || '--'}</div>
                    }
                },
                {
                    title: '可约时间段',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.startTime || '--'} - {row.endTime || '--'}</div>
                        </div>

                    },
                },
                {
                    title: '可约量/天',
                    render: (h, { row }) => {
                        return <div>{row.totalQty || '--'}</div>
                    }
                },
                {
                    title: '单据类型',
                    render: (h, { row }) => {
                        return <div>{row.goodTypeCode || '--'}</div>
                    }
                },
                {
                    title: '状态',
                    render: (h, { row }) => {
                        return <div>{row.status == 0 ? '未用' : '启用' || '--'}</div>
                    }
                },
                {
                    title: '更新时间',
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },

    },

};
